<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" width="14.807"
    height="18.081" viewBox="0 0 14.807 18.081"
  >
    <g data-name="그룹 202">
      <g
        data-name="그룹 65" transform="rotate(180 7.403 9.04)"
        style="clip-path:url(#npq1blrzea)"
      >
        <path
          data-name="패스 42"
          d="M6.954.155.223 5.579A.576.576 0 0 0 0 6.027v3.616a.605.605 0 0 0 .4.551.737.737 0 0 0 .724-.1L7.4 5.03l6.28 5.061a.733.733 0 0 0 .724.1.606.606 0 0 0 .4-.551V6.027a.582.582 0 0 0-.222-.448L7.855.155a.733.733 0 0 0-.9 0"
        />
        <path
          data-name="패스 43"
          d="M6.954.155.223 5.579A.576.576 0 0 0 0 6.027v3.616a.605.605 0 0 0 .4.551.737.737 0 0 0 .724-.1L7.4 5.03l6.28 5.061a.733.733 0 0 0 .724.1.606.606 0 0 0 .4-.551V6.027a.582.582 0 0 0-.222-.448L7.855.155a.733.733 0 0 0-.9 0"
          transform="translate(0 7.834)"
        />
      </g>
    </g>
  </svg>
</template>